/**
 * 文件的下载逻辑
 * @author huangshuo
 * time 2019-12-24
 */

import * as Util from 'js/util/util.js'
import Cookie from 'js/lib/cookie.js'

const { postData } = require('js/api/getdata').default


/**
 * 多文件下载
 * @param data [{meata}...]
 * @param confirm   确认下载
 */
function mulDownload(currentData, confirm = false, storageUrl, callback) {
  // const op_info = []
  // for (let i = 0; i < currentData.length; i++) {
  //   op_info.push(
  //     {
  //       neid: currentData[i].neid,
  //       path_type: currentData[i].path_type,
  //       from: currentData[i].from,
  //       prefix_neid: currentData[i].prefix_neid,
  //     },
  //   )
  // }
  //  debugger
  // // 定义包信息
  // const packInfo = {
  //   json: JSON.stringify({ op_info }),
  // }
  // // 父目录路径
  // const path = currentData[0].path.split('/')
  // path.pop()
  // const params = {
  //   url: path.join('/'), // 父目录路径,收到的共享要这个参数
  // }
  //
  // // 拼接confirm
  // confirm ? params.url += '?confirm=yes' : ''
  // postData('downloadFilePackage', packInfo, params).then((res) => {
  //   if (res.status === 200) {
  //     if (Util.isClient()) { // 客户端无病毒文件的下载
  //       clientDownlaod(currentData)
  //     } else { // web无病毒文件的下载
  //       webDownload(res, currentData)
  //     }
  //   }
  //   // 成功下载的回调
  //   if (typeof callback === 'function') callback(true, res)
  // }).catch((err) => {
  //   // 将异常信息抛出处理
  //   if (typeof callback === 'function') callback(false, err)
  // })
  const pathes = []
  pathes.push(getParentPath(currentData[0].path))
  const uri = archives({
    pathes,
    url: currentData[0].dataUrl || '',
    path_type: currentData[0].path_type,
    from: currentData[0].from,
    nsid: currentData[0].nsid,
    prefix_neid: currentData[0].prefix_neid,
  })
  setUri(uri, currentData, storageUrl)
}


// /**
//  * web端的下载方式(多文件)
//  */
// function webDownload(res, currentData) {
//   // 获取要下载的包文件url地址
//   let download_url = res.data.package_url
//
//   // 定义当前文件的pathType
//   const pathType = currentData[0].path_type
//   const from = currentData[0].form
//   const { prefix_neid } = currentData[0]
//
//   // 组合url路径
//   download_url += `${'?' + 'path_type='}${pathType}&` + `X-LENOVO-SESS-ID=${Cookie.get('X-LENOVO-SESS-ID')}`
//   const actionurl = download_url.substr(0, download_url.indexOf('?')).replace(/%/g, '%25').replace(/#/g, '%23')
//   const query = Util.queryString(download_url.substring(download_url.indexOf('?')))
//
//   // 创建dom
//   const postform = document.createElement('form')
//   postform.action = `${actionurl}?path_type=${pathType}&X-LENOVO-SESS-ID=${Cookie.get('X-LENOVO-SESS-ID')}`
//   if (/^share/.test(query.path_type)) {
//     postform.action += `&from=${from}`
//     postform.action += `&prefix_neid=${prefix_neid}`
//   }
//   postform.enctype = 'application/x-www-form-urlencoded'
//   postform.method = 'post'
//   postform.target = 'download-iframe'
//   for (let i = 0; i < currentData.length; i++) {
//     const input = document.createElement('input')
//     input.type = 'hidden'
//     input.name = 'files[]'
//     input.value = currentData[i].path
//     postform.appendChild(input)
//   }
//   document.body.appendChild(postform)
//   postform.submit()
//   // document.body.removeChild(postform);
// }


// /**
//  * 客户端的下载方式(单文件/多文件)
//  */
// function clientDownlaod(currentData) {
//   const dlInfo = []
//   if (currentData instanceof Array && currentData.length > 1) {
//     for (let i = 0, len = currentData.length; i < len; i++) {
//       dlInfo.push(currentData[i])
//     }
//   } else {
//     dlInfo.push(currentData[0])
//   }
//   // 下载数据
//   jsToNative('DownloadFile', JSON.stringify({ remotePaths: dlInfo }))
// }
/**
 * uri拼接，调用下载接口
 * @param uri
 * @param param
 */
const setUri = (uri, param, storageUrl) => {
  if (param.length || param.is_dir) {
    //  打包下载
    const arrFormData = []
    let fileInfo = []
    if (param.length) {
      param.forEach((item) => arrFormData.push(item.path))
      fileInfo = param.map(({
        path, from, prefix_neid: prefixNeid, path_type: pathType,
      }) => ({
        from: from || '',
        path: encodeURIComponent(path),
        prefix_neid: prefixNeid || '',
        path_type: pathType,
      }))
    } else {
      arrFormData.push(param.path)
      fileInfo = [{
        from: param.from || '',
        path: encodeURIComponent(param.path),
        prefix_neid: param.prefix_neid || '',
        path_type: param.path_type,
      }]
    }
    const actionUrl = uri.substr(0, uri.indexOf('?'))
    const query = queryString(uri.substring(uri.indexOf('?')))
    const storageURL = storageUrl
    const postform = document.createElement('form')
    postform.action = `${storageURL + actionUrl}?nsid=${query.nsid || ''}&prefix_neid=${query.prefix_neid || ''}&from=${query.from || ''}&path_type=${query.path_type}&S=${Cookie.get('S')}`
    postform.enctype = 'application/x-www-form-urlencoded'
    postform.method = 'post'
    //  为form提交创建iframe
    createIframe()
    postform.target = 'downloadIframe'
    arrFormData.forEach((v) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'files[]'
      input.value = encodeURIComponent(v)
      postform.appendChild(input)
    })
    const fileInfoInput = document.createElement('input')
    fileInfoInput.type = 'hidden'
    fileInfoInput.name = 'fileInfo'
    fileInfoInput.value = JSON.stringify(fileInfo)
    postform.appendChild(fileInfoInput)
    document.body.appendChild(postform)
    postform.submit()
    document.body.removeChild(postform)
    // 多文件下载--日志埋点,开始
    let postParam = {}
    if (param.is_dir) {
      // 单文件夹
      postParam = {
        category: 0,
        action: 2,
        nsid: param.nsid,
        pathType: param.path_type,
        entityStr1: param.path,
        entityStr2: param.path.substring(0, param.path.lastIndexOf('/')) === '' ? '/' : param.path.substring(0, param.path.lastIndexOf('/')),
      }
    }
    // sendLogBuryingPointMethods(postParam)
    // 日志埋点,结束
  }
  return false
}

/**
 * 生成打包下载uri
 * @param params
 * @returns {string}
 */
const archives = (params) => {
  let uri = ''
  let pathroot = ''
  if (params.pathes.length === 1) {
    [pathroot] = params.pathes
  } else {
    pathroot = params.pathes[0].path
  }
  if (pathroot) {
    let arr = pathroot.split('/')
    arr = arr.map((val) => encodeURIComponent(val))
    pathroot = arr.join('/')
  }
  uri = `archives/databox${pathroot}/?path_type=${params.path_type}&nsid=${params.nsid}&`
  if (params.from === '0' || params.from) {
    uri += `from=${params.from}&`
  }
  if (params.prefix_neid) {
    uri += `prefix_neid=${params.prefix_neid}&`
  }

  const files = []
  params.pathes.forEach((v) => {
    files.push(`files[]=${encodeURIComponent(v)}`)
  })

  uri += files.join('&')

  uri = uri.replace('//', '/')

  return uri
}

const getParentPath = (path) => {
  if (path === undefined) {
    return ''
  }
  let parentPath = path.substring(0, path.lastIndexOf('/'))
  if (parentPath === '/') {
    parentPath = ''
  }
  return parentPath
}
const queryString = (strArg) => {
  let str = strArg
  str = str.substr(1)
  const keyValArr = str.split('&')
  const keyValObj = {}
  for (let i = 0, len = keyValArr.length; i < len; i += 1) {
    const a = keyValArr[i].split('=')
    if (a.length > 1) {
      [, keyValObj[a[0].toLowerCase()]] = a
    }
  }
  return keyValObj
}

/**
 *获取当前iframe
 */
const getIframe = () => {
  const objDownloadIframe = document.getElementById('downloadIframe')
  return objDownloadIframe
}

/**
 *创建iframe
 */
const createIframe = () => {
  if (!getIframe()) {
    const downloadIframe = document.createElement('iframe')
    downloadIframe.style.display = 'none'
    downloadIframe.id = 'downloadIframe'
    downloadIframe.name = 'downloadIframe'
    document.body.appendChild(downloadIframe)
  }
}

// 导出
export { mulDownload }
